module.exports = __webpack_public_path__ + "static/media/fr-david.6fd698ec.jpg";